import axios from '../../axios'
import { GET_SURVEY_REVIEW, CREATE_SURVEY_REVIEW, DELETE_SURVEY_REVIEW, UPDATE_SURVEY_REVIEW, ACTIVE_SURVEY_REVIEW, INACTIVE_SURVEY_REVIEW,
  GET_GOOGLE_REVIEW, CREATE_GOOGLE_REVIEW, DELETE_GOOGLE_REVIEW, UPDATE_GOOGLE_REVIEW, ACTIVE_GOOGLE_REVIEW, INACTIVE_GOOGLE_REVIEW, GET_REVIEW_LIST, GET_REVIEW_REPORT,
 REPLY_GOOGLE_REVIEW , UPDATE_GOOGLE_REPLY_REVIEW ,DELETE_GOOGLE_REPLY_REVIEW, REPLY_GOCHECKIN_REVIEW, GET_SYSTEM_MESSAGE, GET_STAFF_RATING_ANSWER,
  CREATE_ANSWER, UPDATE_ANSWER, CHANGE_ANSWER_STATUS, GET_STAFF_RATING_LIST, GET_DEVICE_LIST, DELETE_DEVICE, UPDATE_STAFF_RATING_DEVICE, CHECK_REVIEW_REPLY_PERMISSION} from "./reviewListTypes";
import { URL_GET_SURVEY_REVIEW, URL_CREATE_SURVEY_REVIEW, URL_UPDATE_SURVEY_REVIEW, URL_DELETE_SURVEY_REVIEW, URL_ACTIVE_SURVEY_REVIEW, URL_INACTIVE_SURVEY_REVIEW,
  URL_GET_GOOGLE_REVIEW, URL_CREATE_GOOGLE_REVIEW, URL_DELETE_GOOGLE_REVIEW, URL_UPDATE_GOOGLE_REVIEW, URL_ACTIVE_GOOGLE_REVIEW, URL_INACTIVE_GOOGLE_REVIEW, URL_GET_REVIEW_LIST,
  URL_GET_REVIEW_REPORT, URL_REPLY_GOOGLE_REVIEW, URL_DELETE_GOOGLE_REPLY_REVIEW, URL_REPLY_GOCHECKIN_REVIEW, URL_GET_SYSTEM_MESSAGE ,URL_UPDATE_GOOGLE_REPLY_REVIEW,
  URL_GET_STAFF_RATING_ANSWER, URL_CREATE_ANSWER, URL_UPDATE_ANSWER, URL_CHANGE_ANSWER_STATUS, URL_GET_STAFF_RATING_LIST, URL_GET_DEVICE_LIST, URL_DELETE_DEVICE, 
  URL_UPDATE_STAFF_RATING_DEVICE, URL_CHECK_REVIEW_REPLY_PERMISSION} from "./reviewListUrls";
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'

export default {
  [GET_REVIEW_LIST] ({commit}, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_REVIEW_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_REVIEW_LIST, data);
              resolve(data);
            } else {
              commit(GET_REVIEW_LIST, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_REVIEW_LIST, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
          // if(response.data.result !== null) {
          //   commit(GET_REVIEW_LIST, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_REVIEW_REPORT] ({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_REVIEW_REPORT}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_REVIEW_REPORT, data);
              resolve(data);
            } else {
              commit(GET_REVIEW_REPORT, null);
              resolve(null);
            }
          } else {
            commit(GET_REVIEW_REPORT, null);
            resolve(null);
          }
          // if(response.data.result !== null) {
          //   commit(GET_REVIEW_LIST, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_SURVEY_REVIEW] ({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SURVEY_REVIEW}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SURVEY_REVIEW, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.result !== null) {
          //   commit(GET_SURVEY_REVIEW, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_GOOGLE_REVIEW] ({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_GOOGLE_REVIEW}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_GOOGLE_REVIEW, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.result !== null) {
          //   commit(GET_GOOGLE_REVIEW, response.data.result.data)
          //   resolve(response)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_STAFF_RATING_ANSWER] ({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_STAFF_RATING_ANSWER}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_STAFF_RATING_ANSWER, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_DEVICE_LIST] ({commit}) {
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_DEVICE_LIST}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_DEVICE_LIST, data);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [REPLY_GOOGLE_REVIEW] ({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_REPLY_GOOGLE_REVIEW}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_REVIEW_LIST, item.infoObj);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [UPDATE_GOOGLE_REPLY_REVIEW] ({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_GOOGLE_REPLY_REVIEW}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_REVIEW_LIST, item.infoObj);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error);})
    })
  },

  [DELETE_GOOGLE_REPLY_REVIEW] ({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_DELETE_GOOGLE_REPLY_REVIEW}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_REVIEW_LIST, item.infoObj);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_SYSTEM_MESSAGE] ({commit}, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_SYSTEM_MESSAGE}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_SYSTEM_MESSAGE, data);
              resolve(data);
            } else {
              commit(GET_SYSTEM_MESSAGE, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_SYSTEM_MESSAGE, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [REPLY_GOCHECKIN_REVIEW] ({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_REPLY_GOCHECKIN_REVIEW}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_SYSTEM_MESSAGE, {customer_id: item.customer_id});
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },


  [CREATE_SURVEY_REVIEW] ({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CREATE_SURVEY_REVIEW}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_SURVEY_REVIEW);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message.content[0]);
          }
          // if (response.data.status == "FAIL") {
          //   reject(response.data.message.content[0])
          // }
          // else {
          //   dispatch('GET_SURVEY_REVIEW');
          //   resolve(response.data)
          // }
        })
        .catch((error) => { reject(error) })
    })
  },

  [CREATE_GOOGLE_REVIEW] ({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CREATE_GOOGLE_REVIEW}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_GOOGLE_REVIEW);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if (response.data.status == "FAIL") {
          //   reject(response.data.message.content[0])
          // }
          // else {
          //   dispatch('GET_GOOGLE_REVIEW');
          //   resolve(response.data)
          // }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  [CREATE_ANSWER] ({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CREATE_ANSWER}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_STAFF_RATING_ANSWER);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  [UPDATE_SURVEY_REVIEW]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      let data = new FormData();
      for(var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_SURVEY_REVIEW}${param}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_SURVEY_REVIEW);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message)
          // }
          // else {
          //   dispatch('GET_SURVEY_REVIEW');
          //   resolve(response.data)
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_GOOGLE_REVIEW]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      let data = new FormData();
      for(var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_GOOGLE_REVIEW}${param}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_GOOGLE_REVIEW);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message)
          // }
          // else {
          //   dispatch('GET_GOOGLE_REVIEW');
          //   resolve(response.data)
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [UPDATE_ANSWER]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      // let param = new URLSearchParams(item).toString();
      let data = new FormData();
      for(var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_ANSWER}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_STAFF_RATING_ANSWER);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message)
          // }
          // else {
          //   dispatch('GET_GOOGLE_REVIEW');
          //   resolve(response.data)
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [DELETE_SURVEY_REVIEW]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_DELETE_SURVEY_REVIEW}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_SURVEY_REVIEW);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message);
          // }
          // else {
          //   resolve(response.data);
          //   dispatch('GET_SURVEY_REVIEW');
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [DELETE_GOOGLE_REVIEW]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();

      axios.get(`${URL_DELETE_GOOGLE_REVIEW}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_GOOGLE_REVIEW);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message);
          // }
          // else {
          //   resolve(response.data);
          //   dispatch('GET_GOOGLE_REVIEW');
          // }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [DELETE_DEVICE] ({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_DELETE_DEVICE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // dispatch(GET_DEVICE_LIST);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },
  // eslint-disable-next-line
  [UPDATE_STAFF_RATING_DEVICE] ({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_UPDATE_STAFF_RATING_DEVICE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // dispatch(GET_STAFF_RATING_ANSWER);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [CHANGE_ANSWER_STATUS]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      // let param = new URLSearchParams(item).toString();
      let data = new FormData();
      for(var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_CHANGE_ANSWER_STATUS}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              dispatch(GET_STAFF_RATING_ANSWER);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },

  // eslint-disable-next-line
  [ACTIVE_SURVEY_REVIEW]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();

      axios.get(`${URL_ACTIVE_SURVEY_REVIEW}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // dispatch(GET_SURVEY_REVIEW);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message);
          // }
          // else {
          //   resolve(response.data);
          //   dispatch('GET_SURVEY_REVIEW');
          // }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [ACTIVE_GOOGLE_REVIEW]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();

      axios.get(`${URL_ACTIVE_GOOGLE_REVIEW}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // dispatch(GET_GOOGLE_REVIEW);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [INACTIVE_SURVEY_REVIEW]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();
      axios.get(`${URL_INACTIVE_SURVEY_REVIEW}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // dispatch(GET_SURVEY_REVIEW)
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message);
          // }
          // else {
          //   resolve(response.data);
          //   dispatch('GET_SURVEY_REVIEW');
          // }
        })
        .catch((error) => { reject(error) });
    })
  },
  // eslint-disable-next-line
  [INACTIVE_GOOGLE_REVIEW]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams(item).toString();

      axios.get(`${URL_INACTIVE_GOOGLE_REVIEW}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              // dispatch(GET_GOOGLE_REVIEW);
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
          // if(response.data.status == 'FAIL') {
          //   reject(response.data.message);
          // }
          // else {
          //   resolve(response.data);
          //   dispatch('GET_GOOGLE_REVIEW');
          // }
        })
        .catch((error) => { reject(error) });
    })
  },

  [CHECK_REVIEW_REPLY_PERMISSION] ({commit}, item) {
    let param = '';
    if(item) {
      param = new URLSearchParams(item).toString();
    }
    return new Promise((resolve, reject) => {
      axios.get(`${URL_CHECK_REVIEW_REPLY_PERMISSION}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) })
    })
  },

  [GET_STAFF_RATING_LIST] ({commit}, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_STAFF_RATING_LIST}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_STAFF_RATING_LIST, data);
              resolve(data);
            } else {
              commit(GET_STAFF_RATING_LIST, {});
              resolve({});
            }
          } else {
            commit(GET_STAFF_RATING_LIST, {});
            resolve({});
          }
        })
        .catch((error) => { reject(error) })
    })
  },
}
